import { configs } from '@hero/configs';

function useGetProductImages({ product }) {
  if (!product) return [];

  //! NOTE: We can't use just `return product.images`,
  //! because always 1 image comes from `product.images`
  let images = [];
  const skuImages = product?.skus?.map(sku => sku?.images?.[0]);
  if (configs?.general?.useProductSkuImages && skuImages?.length) {
    images = skuImages;
  } else if (product?.images) {
    images = product.images;
  }
  return images;
}

export { useGetProductImages };
